import { TableColumn } from '../consts';
import CancelOrderCell from './CancelOrderCell';
import InfoRow from './InfoRow';
import { DgcOrder } from 'api/types/dgc/dgcOrder';
import { ReactNode } from 'react';

type Props = {
  order: DgcOrder;
  columns: TableColumn[];
  canCancel: boolean;
  renderCell: (order: DgcOrder, column: TableColumn) => ReactNode;
  onSelect: () => void;
};

function OrderCard({ order, columns, canCancel, renderCell, onSelect }: Props) {
  const copyableColumns = columns.filter((column) => column.copyable);
  const otherColumns = columns.filter((column) => !column.copyable);

  return (
    <div className="flex flex-col gap-4 px-4 py-6">
      {/* Copy controls sit outside the select button, since buttons can't be nested. */}
      {copyableColumns.map((column) => (
        <div key={column.key} onClick={onSelect}>
          <InfoRow label={column.headerLabel} value={renderCell(order, column)} breakAll copyable />
        </div>
      ))}
      <button
        type="button"
        onClick={onSelect}
        aria-label={`View details for order ${order.order_ref ?? ''}`}
        className="flex flex-col gap-4 text-left rounded focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-palette-secondary"
      >
        {otherColumns.map((column) => (
          <InfoRow key={column.key} label={column.headerLabel} value={renderCell(order, column)} breakAll />
        ))}
      </button>
      {canCancel && (
        <div className="flex justify-end">
          <CancelOrderCell orderUuid={order.uuid} orderRef={order.order_ref} status={order.status} />
        </div>
      )}
    </div>
  );
}

export default OrderCard;
